<template>
    <div class="zakaz-login">
        <div class="container">
            <div class="row flex-row">
                <div class="col lg-6 sm-12">
                    <div class="row">
                        <div class="col lg-8 md-10 sm-12 col--centered">
                            <div class="flex-c zakaz-login__social">
                                <div class="text_15 text_bold">{{ $t("zakaz_login_title") }}</div>
                                <!-- <SocialLogin :showLabel="false" type="login" /> -->
                            </div>
                            <LoginForm :showLabel="false" endpoint="login_to_cart"></LoginForm>
                        </div>
                    </div>
                </div>
                <div class="col lg-6 sm-12 col-border">
                    <div class="row">
                        <div class="col lg-8 md-10 sm-12 col--centered">
                            <div class="text_15 text_bold">{{ $t("zakaz_login_title_first") }}</div>
                            <div class="text_13 color-text_2 zakaz-login__text">
                                {{ $t("zakaz_login_description") }}
                            </div>
                            <nuxt-link
                                to="/zakaz"
                                class="button button--secondary"
                                :class="$device.isMobile ? 'button--wide' : 'button--large'"
                                >{{ $t("zakaz_login_continue") }}</nuxt-link
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import SocialLogin from "~/components/SocialLogin";
import LoginForm from "~/components/LoginForm";
import { mapGetters } from "vuex";

export default {
    name: "ZakazLogin",
    components: {
        // SocialLogin,
        LoginForm,
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
    },
    methods: {
        getCrumbs() {
            return [
                {
                    name: this.$i18n.t("lk_auth"),
                },
            ];
        },
    },
    watch: {
        langust() {
            this.$store.commit("crumbs/change", this.getCrumbs());
        },
    },
    mounted() {
        this.$store.commit("crumbs/change", this.getCrumbs());
    },
};
</script>
<style lang="less" scoped>
.zakaz-login {
    &__social {
        justify-content: space-between;
        @media @sm {
            flex-direction: column;
            align-items: flex-start;
        }
    }
    &__text {
        margin: 48px 0 53px;
        @media @sm {
            margin: 28px 0 33px;
        }
    }
    .login-form {
        padding-top: 0;
    }
    .col-border {
        border-left: 1px solid @border2;
        @media @sm {
            border-left: 0;
            border-top: 1px solid @border2;
            padding-bottom: 80px !important;
        }
    }
    .flex-row > .col {
        padding-top: 146px;
        padding-bottom: 146px;
        @media @sm {
            padding-top: 32px;
            padding-bottom: 0;
        }
    }
    .social-login {
        @media @sm {
            margin-bottom: 0;
        }
    }
}
</style>
